module.exports = __webpack_public_path__ + "static/media/copy.e30ab7f2.svg";